<template>
  <div class="filter">
    <input-vue
      v-if="filters[index].searchable"
      class="filter__search"
      :placeholder="$t('filter.search.placeholder')"
      :name="$t('filter.search.placeholder')"
      :aria-label="$t('filter.search.placeholder')"
      v-model="searchValue"
    />
    <div
      class="filter__options"
      :class="{
        'filter__options--swatches': swatches
      }"
    >
      <label
        class="filter__option"
        :class="{
          'filter__option--swatch': swatches,
          'filter__option--swatch-active': swatches && activeOptions.includes(option.value),
          'filter__option--disabled': showOptionOnCountZero && option.count === 0
        }"
        v-for="option in transformedOptions"
        :key="`${name}-${option.value}`"
        v-show="showOptionOnCountZero || option.count > 0"
        :for="`${name}-${option.value}`"
      >
        <input
          class="filter__input"
          type="checkbox"
          name="name"
          v-model="activeOptions"
          :value="option.value"
          :id="`${name}-${option.value}`"
          :disabled="showOptionOnCountZero && option.count === 0"
          @change="optionChangeHandler"
        >
        <span
          class="filter__box"
          role="checkbox"
          tabindex="0"
          @keydown="handleKeyDown"
          :aria-label="$t('global.checkbox.aria.label',[name])"
          :class="[
            swatches ? 'filter__box--swatch' : '',
            swatches && option.swatchType === 'name' ? `swatch-color_${option.swatch}` : ''
          ]"
        />
        <span
          class="filter__label"
          :class="{
            'filter__label--swatch': swatches
          }"
        >
          {{ option.label }}
          <span
            class="filter__option-product-count"
            v-if="option.count"
          >
            ({{ option.count }})
          </span>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
  import plpStateComputedMixin from '../../utilities/vueMixins/plpStateComputedMixin/plpStateComputedMixin.js';
  import InputVue from '../inputVue/inputVue.vue';

  export default {
    components: {
      InputVue
    },
    mixins: [
      plpStateComputedMixin
    ],
    props: {
      name: {
        type: String,
        default: null
      },
      updatePageOnChange: {
        type: Boolean,
        default: true
      },
      showOptionOnCountZero: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        searchValue: '',
        activeOptions: this.$store.state.productsListPage.filters.find(filter => filter.name === this.name).activeOptions
      };
    },
    created() {
      this.$store.subscribe(mutation => {
        if (mutation.type === 'productsListPage/updateFiltersState') {
          this.updateFiltersStateHandler();
        }
      });
      this.$store.subscribeAction({
        after: (action) => {
          if (action.type === 'productsListPage/historyPopState') {
            this.updateFiltersStateHandler();
          }
        }
      });
    },
    methods: {
      optionChangeHandler() {
        this.$store.dispatch('productsListPage/filterUpdate', {
          index: this.index,
          activeOptions: this.activeOptions,
          updatePageOnChange: this.updatePageOnChange
        });
      },
      updateFiltersStateHandler() {
        if (this.filter) {
          this.activeOptions = this.filter.activeOptions;
        }
      },
      handleKeyDown(event) {
        if (event.key === 'Enter' || event.code === 'Space') {
          event.preventDefault();
          event.target.click();
        }
      }
    },
    computed: {
      index() {
        return this.filters.findIndex(filter => filter.name === this.name);
      },
      filter() {
        return this.filters.find(filter => filter.name === this.name);
      },
      transformedOptions() {
        let test = new RegExp(this.searchValue, 'gi');

        return this.filter.options
          .filter(option => {
            return this.searchValue === '' || option.label.match(test);
          })
          .sort((option1, option2) => {
            if (this.swatches) {
              return 0;
            }

            let option1Selected = this.activeOptions.includes(option1.value);
            let option2Selected = this.activeOptions.includes(option2.value);

            return option1Selected && !option2Selected ? -1 : (!option1Selected && option2Selected ? 1 : 0);
          });
      },
      swatches() {
        return this.filter.type === 'color';
      }
    }
  };

</script>
